import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { TrainingDetailPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/trainings/lib/ContentCollectionsBootstrap'

const ContentRoot = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useParams()

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data } = useQuery(TrainingDetailPageDocument, {
    variables: {
      trainingId: Number(id),
      resourceId: String(id),
      companyId,
    },
    fetchPolicy: 'cache-only',
  })

  const hasContentFF = Boolean(
    data?.features.featuresConnection.nodes.find(
      (n) => n.name === 'dev_training_lms' && n.enabled == true
    )
  )

  if (!hasContentFF) {
    navigate(navigation.trainings.list.details_revamp.view.overview.fullPath({ id: Number(id) }))
  }

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default ContentRoot
